class CustomEventBus {
  private listeners: {
    [event: string]: Array<(message: string, error?: Error) => void>
  } = {}

  on(event: string, callback: (message: string, error?: Error) => void): void {
    if (!this.listeners[event]) {
      this.listeners[event] = []
    }
    this.listeners[event].push(callback)
  }

  off(event: string, callback: (message: string, error?: Error) => void): void {
    if (this.listeners[event]) {
      this.listeners[event] = this.listeners[event].filter(
        (listener) => listener !== callback,
      )
    }
  }

  emit(event: string, message: string, error?: Error): void {
    this.listeners[event]?.forEach((callback) => callback(message, error))
  }
}

export const customEventBus = new CustomEventBus()
